// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__v9tkP","paramInput":"JobSimulator_paramInput__mEmq6","input":"JobSimulator_input__1uqWz"};